module.exports = __webpack_public_path__ + "wallet1.svg?a5773766278caafab79c47a320653c62";